<template>
  <div>
    <section class="xs-banner inner-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 align-self-center">
            <div class="xs-banner-content">
              <h1 class="banner-sub-title wow fadeInLeft">Latest Info</h1>
              <h1 class="banner-title wow fadeInLeft" data-wow-duration="1.5s">OUR BLOG POST</h1>
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li>
                  <router-link :to="{ path: '/' }">
                    Home
                  </router-link>
                </li>
                <li>Blog</li>
              </ul>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 align-self-end">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/blog.png" alt="hosting image">
              <img src="../assets/images/info-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/board.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <section id="main-container" class="xs-section-padding blog main-container" role="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <!-- 1st post start -->
            <div class="blog-lsit-group">
              <div class="xs-blog-list blog-lsit-style-2">

                <div
                  class="post post-1276 type-post status-publish format-standard has-post-thumbnail hentry category-shared-hosting tag-30k tag-awwards tag-best-hosting">

                  <div class="post-media"><img width="730" height="448"
                                               src="../assets/images/post_02.jpg"
                                               class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                               loading="lazy"
                                               srcset="../assets/images/post_02.jpg 730w, ../assets/images/post_02-300x184.jpg 300w"
                                               sizes="(max-width: 730px) 100vw, 730px"/></div>
                  <div class="post-body ">
                    <div class="entry-header">
                      <h2 class="entry-title">

                        <a href="#">Attentive was born in
                          2015 help sales teams</a>
                      </h2>
                      <div class="post-meta"><span class="post-author"><img alt=''
                                                                            src='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg'
                                                                            srcset='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg 2x'
                                                                            class='avatar avatar-55 photo' height='55'
                                                                            width='55' loading='lazy'/><a
                        href="#">admin</a></span><span
                        class="meta-categories post-cat"><i class="icon icon-folder2"> </i>   <a
                        href="#"
                        rel="category tag">Shared Hosting</a> </span><span class="post-meta-date"><i
                        class="icon icon-calendar-1"></i> August 3, 2018</span></div>
                      <div class="entry-content">
                        There’s such a thing as “too much information”, especially for the companies scaling out their
                        sales operations. That’s why Attentive was born in 2015 help sales teams make their increasing
                        pipelines simpler to manage. Indeed,&hellip;
                      </div>
                      <div class="post-footer xs-right"><a
                        href="#"
                        class="simple-btn icon-right">Read More<i class="icon icon-arrow-right"></i></a></div>
                    </div>
                  </div>
                </div>
                <div
                  class="post post-1266 type-post status-publish format-standard has-post-thumbnail hentry category-reseller-hosting tag-hosting">

                  <div class="post-media"><img width="730" height="448"
                                               src="../assets/images/post_01.jpg"
                                               class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                               loading="lazy"
                                               srcset="../assets/images/post_01.jpg 730w, ../assets/images/post_01-300x184.jpg 300w"
                                               sizes="(max-width: 730px) 100vw, 730px"/></div>
                  <div class="post-body ">
                    <div class="entry-header">
                      <h2 class="entry-title">

                        <a href="#">Life won&#8217;t one beast
                          air over above all</a>
                      </h2>
                      <div class="post-meta"><span class="post-author"><img alt=''
                                                                            src='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg'
                                                                            srcset='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg 2x'
                                                                            class='avatar avatar-55 photo' height='55'
                                                                            width='55' loading='lazy'/><a
                        href="#">admin</a></span><span
                        class="meta-categories post-cat"><i class="icon icon-folder2"> </i>   <a
                        href="#"
                        rel="category tag">Reseller Hosting</a> </span><span class="post-meta-date"><i
                        class="icon icon-calendar-1"></i> August 3, 2018</span></div>
                      <div class="entry-content">
                        There’s such a thing as “too much information”, especially for the companies scaling out their
                        sales operations. That’s why Attentive was born in 2015 help sales teams make their increasing
                        pipelines simpler to manage. Indeed,&hellip;
                      </div>
                      <div class="post-footer xs-right"><a
                        href="#"
                        class="simple-btn icon-right">Read More<i class="icon icon-arrow-right"></i></a></div>
                    </div>
                  </div>
                </div>
                <div
                  class="post post-884 type-post status-publish format-video has-post-thumbnail hentry category-uncategorized tag-best-hosting tag-global tag-hosting post_format-post-format-video">

                  <div class="post-media"><img width="730" height="448"
                                               src="../assets/images/blog-list-image-2.jpg"
                                               class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                               loading="lazy"
                                               srcset="../assets/images/blog-list-image-2.jpg 730w, ../assets/images/blog-list-image-2-300x184.jpg 300w"
                                               sizes="(max-width: 730px) 100vw, 730px"/>
                    <div class="video-pop-up-content">
                      <a href="https://www.youtube.com/watch?v=zDAYZU4A3w0" class="xs-video-popup gloosy-btn">
                        <i class="icon icon-play-button2"></i>
                      </a>
                    </div>
                    <div class="xs-overlay xs-bg-black"></div>

                  </div>
                  <div class="post-body ">
                    <div class="entry-header">
                      <h2 class="entry-title">

                        <a href="#">Best and fastest data server
                          ever</a>
                      </h2>
                      <div class="post-meta"><span class="post-author"><img alt=''
                                                                            src='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg'
                                                                            srcset='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg 2x'
                                                                            class='avatar avatar-55 photo' height='55'
                                                                            width='55' loading='lazy'/><a
                        href="#">admin</a></span><span
                        class="meta-categories post-cat"><i class="icon icon-folder2"> </i>   <a
                        href="#"
                        rel="category tag">Uncategorized</a> </span><span class="post-meta-date"><i
                        class="icon icon-calendar-1"></i> July 19, 2018</span></div>
                      <div class="entry-content">
                        There’s such a thing as “too much information”, especially for the companies scaling out their
                        sales operations. That’s why Attentive was born in 2015 help sales teams make their increasing
                        pipelines simpler to manage. Indeed,&hellip;
                      </div>
                      <div class="post-footer xs-right"><a href="#"
                                                           class="simple-btn icon-right">Read More<i
                        class="icon icon-arrow-right"></i></a></div>
                    </div>
                  </div>
                </div>
                <div
                  class="post post-874 type-post status-publish format-standard has-post-thumbnail hentry category-cloud-computing tag-30k tag-global">

                  <div class="post-media"><img width="730" height="448"
                                               src="../assets/images/blog-list-image-1.jpg"
                                               class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                               loading="lazy"
                                               srcset="../assets/images/blog-list-image-1.jpg 730w, ../assets/images/blog-list-image-1-300x184.jpg 300w"
                                               sizes="(max-width: 730px) 100vw, 730px"/></div>
                  <div class="post-body ">
                    <div class="entry-header">
                      <h2 class="entry-title">

                        <a href="#">Cloud Hosting growing faster
                          todays</a>
                      </h2>
                      <div class="post-meta"><span class="post-author"><img alt=''
                                                                            src='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg'
                                                                            srcset='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg 2x'
                                                                            class='avatar avatar-55 photo' height='55'
                                                                            width='55' loading='lazy'/><a
                        href="#">admin</a></span><span
                        class="meta-categories post-cat"><i class="icon icon-folder2"> </i>   <a
                        href="#"
                        rel="category tag">Cloud Computing</a> </span><span class="post-meta-date"><i
                        class="icon icon-calendar-1"></i> July 19, 2018</span></div>
                      <div class="entry-content">
                        There’s such a thing as “too much information”, especially for the companies scaling out their
                        sales operations. That’s why Attentive was born in 2015 help sales teams make their increasing
                        pipelines simpler to manage. Indeed,&hellip;
                      </div>
                      <div class="post-footer xs-right"><a
                        href="#" class="simple-btn icon-right">Read
                        More<i class="icon icon-arrow-right"></i></a></div>
                    </div>
                  </div>
                </div>
                <div
                  class="post post-127 type-post status-publish format-audio has-post-thumbnail hentry category-shared-hosting tag-awwards tag-global post_format-post-format-audio">

                  <div class="post-media">
                    <iframe width="100%" height="165" scrolling="no" frameborder="no" allow="autoplay"
                            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/48084634&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true&amp;visual=true"></iframe>
                  </div>
                  <div class="post-body ">
                    <div class="entry-header">
                      <h2 class="entry-title">

                        <a href="#">Domain name for student</a>
                      </h2>
                      <div class="post-meta"><span class="post-author">
                        <img alt=''
                                                                            src='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg'
                                                                            srcset='../assets/images/a531fe3e08fa67a663b8404bfd9394dc.jpg 2x'
                                                                            class='avatar avatar-55 photo' height='55'
                                                                            width='55' loading='lazy'/><a
                        href="#">admin</a></span><span
                        class="meta-categories post-cat"><i class="icon icon-folder2"> </i>   <a
                        href="#"
                        rel="category tag">Shared Hosting</a> </span><span class="post-meta-date"><i
                        class="icon icon-calendar-1"></i> July 3, 2018</span></div>
                      <div class="entry-content">
                        There’s such a thing as “too much information”, especially for the companies scaling out their
                        sales operations. That’s why Attentive was born in 2015 help sales teams make their increasing
                        pipelines simpler to manage. Indeed,&hellip;
                      </div>
                      <div class="post-footer xs-right"><a href="#"
                                                           class="simple-btn icon-right">Read More<i
                        class="icon icon-arrow-right"></i></a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul class="pagination justify-content-center">
              <li class="active"><a class="page-link" href="#">1</a></li>
              <li><a href="#" class="page-link">2</a></li>
              <li><a href="#"><i class="fa fa-long-arrow-right"></i></a></li>
            </ul>

          </div>

          <aside id="sidebar" class="sidebar sidebar-right col-md-4" role="complementary">
            <div id="search-2" class="widget widget_search">
              <form method="get" action="#" class="xs-serach">
                <div class="input-group">
                  <input type="search" name="s" placeholder="Search" value="">
                  <button class="search-btn"><i class="icon icon-search"></i></button>
                </div>
              </form>
            </div>
            <div id="categories-2" class="widget widget_categories"><h4 class="xs-title">Categories</h4>
              <ul>
                <li class="cat-item cat-item-26"><a href="#">Cloud
                  Computing</a>
                </li>
                <li class="cat-item cat-item-21"><a href="#">Cloud Hosting</a>
                </li>
                <li class="cat-item cat-item-22"><a href="#">Reseller
                  Hosting</a>
                </li>
                <li class="cat-item cat-item-23"><a href="#">Shared
                  Hosting</a>
                </li>
                <li class="cat-item cat-item-1"><a href="#">Uncategorized</a>
                </li>
              </ul>

            </div>
            <div id="tag_cloud-2" class="widget widget_tag_cloud"><h4 class="xs-title">Popular Tags</h4>
              <div class="tagcloud"><a href="#"
                                       class="tag-cloud-link tag-link-29 tag-link-position-1" style="font-size: 18.5pt;"
                                       aria-label="30k (3 items)">30k</a>
                <a href="#" class="tag-cloud-link tag-link-33 tag-link-position-2"
                   style="font-size: 14.3pt;" aria-label="Awwards (2 items)">Awwards</a>
                <a href="#" class="tag-cloud-link tag-link-34 tag-link-position-3"
                   style="font-size: 18.5pt;" aria-label="Best Hosting (3 items)">Best Hosting</a>
                <a href="#" class="tag-cloud-link tag-link-36 tag-link-position-4"
                   style="font-size: 22pt;" aria-label="Global (4 items)">Global</a>
                <a href="#" class="tag-cloud-link tag-link-28 tag-link-position-5"
                   style="font-size: 14.3pt;" aria-label="Hosting (2 items)">Hosting</a>
                <a href="#" class="tag-cloud-link tag-link-35 tag-link-position-6"
                   style="font-size: 8pt;" aria-label="Personal PC (1 item)">Personal PC</a></div>
            </div>
            <div id="nav_menu-2" class="widget widget_nav_menu"><h4 class="xs-title">Services</h4>
              <div class="menu-services-container">
                <ul id="menu-services" class="menu">
                  <li id="menu-item-1370" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1370">
                    <a href="https://episcloud.com/shared-hosting/">Shared Hosting</a></li>
                  <li id="menu-item-1369" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1369">
                    <a href="https://episcloud.com/reseller-hosting/">Reseller Hosting</a></li>
                  <li id="menu-item-1367" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1367">
                    <a href="https://episcloud.com/cloud-hosting/">Cloud Hosting</a></li>
                  <li id="menu-item-1368" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1368">
                    <a href="https://episcloud.com/vps-hosting/">VPS Hosting</a></li>
                  <li id="menu-item-1366" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1366">
                    <a href="https://episcloud.com/dedicated-hosting/">Dedicated Hosting</a></li>
                </ul>
              </div>
            </div>
            <div id="nav_menu-5" class="widget widget_nav_menu"><h4 class="xs-title">Services</h4>
              <div class="menu-services-container">
                <ul id="menu-services-1" class="menu">
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1370"><a
                    href="https://episcloud.com/shared-hosting/">Shared Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1369"><a
                    href="https://episcloud.com/reseller-hosting/">Reseller Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1367"><a
                    href="https://episcloud.com/cloud-hosting/">Cloud Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1368"><a
                    href="https://episcloud.com/vps-hosting/">VPS Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1366"><a
                    href="https://episcloud.com/dedicated-hosting/">Dedicated Hosting</a></li>
                </ul>
              </div>
            </div>
            <div id="nav_menu-6" class="widget widget_nav_menu"><h4 class="xs-title">Services</h4>
              <div class="menu-services-container">
                <ul id="menu-services-2" class="menu">
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1370"><a
                    href="https://episcloud.com/shared-hosting/">Shared Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1369"><a
                    href="https://episcloud.com/reseller-hosting/">Reseller Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1367"><a
                    href="https://episcloud.com/cloud-hosting/">Cloud Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1368"><a
                    href="https://episcloud.com/vps-hosting/">VPS Hosting</a></li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1366"><a
                    href="https://episcloud.com/dedicated-hosting/">Dedicated Hosting</a></li>
                </ul>
              </div>
            </div>
          </aside> <!-- end sidebar -->

        </div><!-- Main row end -->

      </div><!-- Container end -->
    </section>
  </div>
</template>

<script>
export default {
  name: 'Blog'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Blog.vue